import {
  ISiteStatus,
  SitesSearchDateAddedArg,
  UwV2SitesSearchListParams,
} from '../../../../userway/sdk/UserWayApiClient';
import {createStore, withProps} from '@ngneat/elf';

export interface SitesPagination {
  p?: number;
  q?: number;
}

export interface ISearchParams {
  activeSitesSearchParams: UwV2SitesSearchListParams;
  deletedSitesSearchParams: UwV2SitesSearchListParams;
  pdfSitesSearchParams: UwV2SitesSearchListParams;
  reviewedSitesSearchParams: UwV2SitesSearchListParams;
  sitesPagination: SitesPagination;
}

export function createInitialState(): ISearchParams {
  const localStorageSitesPerPage = localStorage.getItem('sitesPerPage');
  const sitesPerPage = Number(localStorageSitesPerPage) || 10;

  return {
    activeSitesSearchParams: {
      status: ISiteStatus.ACTIVE,
      d: SitesSearchDateAddedArg.NEW,
    },
    deletedSitesSearchParams: {
      status: ISiteStatus.REMOVED,
      d: SitesSearchDateAddedArg.NEW,
    },
    reviewedSitesSearchParams: {
      status: ISiteStatus.PENDING,
      d: SitesSearchDateAddedArg.NEW,
    },
    pdfSitesSearchParams: {
      d: SitesSearchDateAddedArg.NEW,
      isPdfRequest: true,
    },
    sitesPagination: {
      q: sitesPerPage,
      p: 1,
    },
  };
}

export const sitesSearchParamsStore = createStore(
  {name: 'site-search-params'},
  withProps<ISearchParams>(createInitialState()),
);
